export function reverseString(s: string) {
    return s.split("").reverse().join("");
}
